import { render } from "./loginHeader.vue?vue&type=template&id=e0f13a74&ts=true"
import script from "./loginHeader.vue?vue&type=script&lang=ts"
export * from "./loginHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__